const ApiService = {
  init() {
    axios.defaults.baseURL = process.env.VUE_APP_SALESFORCE_URL;
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['Accept-Encoding'] = 'deflate,gzip';
  },
  get(resource, params) {
    return axios.get(`${resource}`, { params });
  },

  post(resource, params, queryParams) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${resource}`, params, queryParams)
        .then((response) => {
          if (response.data) {
            const errorMessage = response.data.errMsg;
            if (errorMessage === null) {
              resolve({
                status: 'success',
              });
            } else {
              resolve({
                status: 'error',
                errorMsg: errorMessage,
              });
            }
          } else {
            resolve({
              status: 'error',
              errorMsg: 'Something went wrong, please try again later',
            });
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  patch(resource, params) {
    return axios.patch(`${resource}`, params);
  },

  put(resource, params) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${resource}`, params)
        .then((response) => {
          if (response.data) {
            const errorMessage = response.data.errMsg;
            if (errorMessage === null) {
              resolve({
                status: 'success',
              });
            } else {
              resolve({
                status: 'error',
                errorMsg: errorMessage,
              });
            }
          } else {
            resolve({
              status: 'error',
              errorMsg: 'Something went wrong, please try again later',
            });
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  delete(resource, params) {
    return axios.delete(`${resource}`, params);
  },
};

export default ApiService;
